import React, { useState } from 'react'
import { useResponsive } from '../../../Components/Hooks';
import { Text } from '../../../Components/Text';
import { Box, FlexBox, ListBox } from '../../../Components/Boxes';
import { Button } from '../../../Components/Input';
import Icon from '../../../Components/Icons';
import MuiSkeletonLoader from '../../../Components/LoadingSkeleton/MuiSkeletonLoader';
import EmptyState from '../../../Components/NoRecordFound';
import FormDialog from '../../../Components/Modals/FormDialog';
import { useDefaultQualificationsSettingsController } from '../SettingsControllers/useDefaultQualificationsController';
import AddDefaultQualificationsDialog from '../Dialogs/AddDefaultQualificationsDialog';

export default function DefaultQualificationsSettings() {
    const isDesktop = useResponsive({ xs: false, sm: true });
    const {
        title,
        defaultQualifications,

        canEdit,
        canAdd,

        moreItemsLeftInPagination,

        onLoadMore,
        onCreate,
        onUpdate,
        onDelete,

        isCreatingConfig,
        isUpdatingConfig,
        isDeletingConfig,
        isGettingConfigs,

        createErrorMessage,
        updateErrorMessage,
        deleteErrorMessage,
        gettingErrorMessage,
    } = useDefaultQualificationsSettingsController()

    const [open, setOpen] = useState(false);
    const [editingDefaultQualification, setEditingDefaultQualification] = useState("")

    function handleDialog(defaultQualification) {
        setOpen(!open)
        setEditingDefaultQualification(defaultQualification)
    }

    return (
        <Box>
            <Text $fontSize="heading-3">{title}</Text>
            {canAdd && <FlexBox
                $justifyContent="flex-end"
                $width="100%"
                $marginTop={2}
                $marginRight={4}
            >
                <Button
                    $onClick={() => {
                        handleDialog();
                    }}
                >
                    <Icon $icon="Add" $color="white"></Icon>
                    <Text $color={"white"}>Add</Text>
                </Button>
            </FlexBox>}
            <Box $marginTop="2" />
            {!isGettingConfigs && defaultQualifications?.map((defaultQualification, index) => {
                return (
                    <ListBox
                        key={defaultQualification.id}
                        $index={index}
                        $onClick={() => {
                            if (canEdit != true) return
                            handleDialog(defaultQualification)
                        }}
                    >
                        <Text $color="text">{defaultQualification.name} ({defaultQualification.grade})</Text>
                    </ListBox>
                )
            })}

            {isGettingConfigs && <FlexBox $width="100%" $marginTop={2} $flexDirection="column">
                {[1, 2, 3].map((val, index) => {
                    return (
                        <Box
                            $marginBottom="2"
                            $width="100%"
                        >
                            <MuiSkeletonLoader
                                $variant="rectangular"
                                $width={"100%"}
                                $height={"40px"}
                            />
                        </Box>
                    );
                })}
            </FlexBox>}

            {!isGettingConfigs && defaultQualifications?.length <= 0 && <FlexBox $marginTop={7} $justifyContent="center">
                <EmptyState />
            </FlexBox>}

            {moreItemsLeftInPagination && <FlexBox $width="100%" $justifyContent="center" $marginTop="6">
                <Button $onClick={() => {
                    onLoadMore()
                }} >Load More</Button>
            </FlexBox>}

            {open && <FormDialog
                $open={open}
                $handleDialog={handleDialog}
                $title={`Add ${title}`}
                $maxWidth="sm"
                $fullWidth
                $fullScreen={!isDesktop}
            >
                <AddDefaultQualificationsDialog
                    defaultQualification={editingDefaultQualification}
                    loading={isUpdatingConfig || isDeletingConfig || isCreatingConfig}
                    onDelete={async () => {
                        await onDelete(editingDefaultQualification)
                        handleDialog()
                    }}
                    onSave={async (val) => {
                        if (editingDefaultQualification) {
                            await onUpdate({
                                id: editingDefaultQualification.id,
                                ...val,
                            })
                        } else {
                            await onCreate({ ...val })
                        }
                        handleDialog()
                    }}
                    handleDialog={handleDialog}
                    errorMessage={updateErrorMessage || deleteErrorMessage || createErrorMessage}
                />
            </FormDialog>}
        </Box>
    )
}